import React from "react";
import SetMain from "../../components/Settings/pages/SetMain.jsx";
import { LanguageContext } from "../../context/LanguageContext.jsx";
import { useContext } from "react";
import { Outlet } from "react-router-dom";
import { useAuth } from "../../context/LoginContext";
// import useFetch from "../../hook/useFetch";

export default function Settings() {
  const { language } = useContext(LanguageContext);
  const { user } = useAuth();
  return (
    <>
      <SetMain language={language} user={user} />
      <Outlet />
    </>
  );
}
